import styles from "./styles.module.scss";
import { ProductTable } from "../ProductTable";

export const ProductSelection = ({
  pOForm,
  setPOForm = () => {},
  ...validationParams
}) => {
  // const {
  //   register,
  //   control,
  //   formState: { errors },
  // } = validationParams;

  // const { storeList } = useSelector((state) => state.profileDetailsReducer);

  return (
    <div className={styles.productSelection}>
      <div>
        <h5 className="mb-0">Order Items</h5>
        <hr />
      </div>
      {/* 
      <div className="d-flex align-items-start justify-content-between flex-wrap">
        <div>
          <p className="dark--text">
            <span className="error--text">*</span>Select Store
          </p>
          <p className="smallest-text-size">
            Select a store to pick items you want to order from a supplier
          </p>
        </div>
        <div className="w-100" style={{ maxWidth: "400px" }}>
          <primaryComponents.SelectFieldV2
            control={control}
            name={"store_id"}
            register={register}
            value={
              // storeList?.find(
              //   (store) => `${store?.id}` === `${pOForm?.store_id}`,
              // )?.name ||
              "Select store"
            }
            options={storeList}
            idKey="id"
            nameKey="name"
            isRequired
            // isDisabled={pOForm?.items?.length > 0}
            errorMessage={errors?.store_id}
            onChange={(value) => {
              setPOForm((prevState) => ({
                ...prevState,
                store_id: value,
              }));
            }}
          />
        </div>
      </div> */}

      <ProductTable
        pOForm={pOForm}
        setPOForm={setPOForm}
        {...validationParams}
      />
    </div>
  );
};
